import { toast as sonnerToast } from 'sonner';

interface ToastPayload {
  title: string;
  description?: string;
}

/**
 * Wrapper around Sonner's toast API.
 * Import this module instead of importing from `sonner` directly in feature code.
 */
export const toast = {
  success(payload: ToastPayload | string): void {
    const data = typeof payload === 'string' ? { title: payload } : payload;
    sonnerToast.success(data.title, {
      description: data.description,
    });
  },

  failure(payload: ToastPayload | string): void {
    const data = typeof payload === 'string' ? { title: payload } : payload;
    sonnerToast.error(data.title, {
      description: data.description,
    });
  },

  info(payload: ToastPayload | string): void {
    const data = typeof payload === 'string' ? { title: payload } : payload;
    sonnerToast.info(data.title, {
      description: data.description,
    });
  },

  message(message: string): void {
    sonnerToast(message);
  },

  // Backwards-compatible alias for existing error usage.
  error(payload: ToastPayload | string): void {
    this.failure(payload);
  },

  dismiss(id?: string | number): void {
    sonnerToast.dismiss(id);
  },
};
